import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Select } from 'antd';
import { CollectionServer, CollectionServerMobile, deleteInArray, errorCatch, GET, ModelMobile, POST, updateInArray, useAuth } from 'fennec-ui';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import User from '../../../../common/User';
import PageLayout from '../../../components/PageLayout';
import { useBreadcrumbs, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext, useSchoolContext } from '../../../../common/Context';
import TabsMenu from '../../../components/TabsMenu';
import CapsuleMenu from '../../../components/CapsuleMenu';
import { Toast } from 'antd-mobile';

const { Option } = Select;


const useStyles = createUseStyles({
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
    },
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function SchoolEducationBlacklist(props) {
    const [ctx, setSchool] = useSchoolContext();
    const classes = useStyles();
    const auth = useAuth();
    const dispatch = useDispatch();

    const sourceKey = "school";

    const filters = () => [
        {
            label: "Фамилия",
            name: "polzovatel.lastname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Имя",
            name: "polzovatel.firstname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Отчество",
            name: "polzovatel.patronymic",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Email",
            name: "polzovatel.email",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "polzovatel.phone",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Дата рождения",
            name: "polzovatel.birthday",
            type: "date",
            filterType: "range",
            // func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    // ----------------------------------------
    const breadcrumbs = useBreadcrumbs()
    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if (count >= i) return p;
            if (!arr[idx]?.context) {
                count++
            }
            p += `/${arr[idx]?.uuid}`
        }
        return p
    }
    // ----------------------------------------

    return (<div className="subcontent">
        <div className={"content"}>
            <PageLayout hideSider={true} hideBreadcrumbs={true}>
                <div style={{ height: "100%", overflowY: "auto", backgroundColor: "white", borderRadius: "4px", padding: "10px" }}>

                    <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} />

                    <div style={{ fontSize: "14px", paddingTop: "15px" }}>
                        {"Черный список школы"}
                    </div>
                    <div style={{ fontSize: "20px" }}>
                        {((ctx) ? ctx.nazvanieShkoliTantsev : "")}
                    </div>

                    {ctx && <CollectionServerMobile
                        noheader={true}
                        // title={"Черный список школы " + ((ctx) ? "\"" + ctx.nazvanieShkoliTantsev + "\"" : "")}
                        name={"CherniiSpisokShkol"}
                        auth={auth}
                        size="small"
                        source={`/api/school/cherniispisok/list/${ctx?.ID}`}
                        filters={filters}
                        mode={"list"}
                        render={(item, idx, { setCollection, setCollectionItem, update }) => {
                            return (<div key={idx} style={{ width: "100%" }} className="students">
                                <div className={classes.item}>
                                    <div style={{ flex: "auto" }}>
                                        <User item={item.polzovatel} noborder={true} />
                                    </div>
                                </div>
                            </div>)
                        }}
                        collectionActions={() => [
                            {
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    GET(auth, `/api/add/school/${ctx?.ID}/cherniispisok/${values.search.ID}`,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data));
                                            close();
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                // form: AddBlacklistlShkoli,
                                steps: [
                                    {
                                        key: "search",
                                        name: "Шаг 1",
                                        action: (values, unlock, close) => {
                                            POST(auth, "/api/find/finduserfilter", { ...values },
                                                ({ data }) => {
                                                    close(data);
                                                },
                                                (err) => {
                                                    Toast.show({
                                                        icon: 'fail',
                                                        content: err.message || err.exception,
                                                    })
                                                    unlock();
                                                });
                                        },
                                        // form: SearchUser,
                                        form: ModelMobile,
                                        meta: [
                                            {
                                                label: "Email",
                                                name: "Email",
                                                type: "string",
                                                display: (v) => v,
                                                validators: {
                                                    required: true,
                                                    min: null,
                                                    max: null,
                                                    pattern: null
                                                },
                                            },
                                            {
                                                label: "Фамилия",
                                                name: "Lastname",
                                                type: "string",
                                                display: (v) => v,
                                                validators: {
                                                    required: true,
                                                    min: null,
                                                    max: null,
                                                    pattern: null
                                                },
                                            },
                                            {
                                                label: "Имя",
                                                name: "Firstname",
                                                type: "string",
                                                display: (v) => v,
                                                validators: {
                                                    required: true,
                                                    min: null,
                                                    max: null,
                                                    pattern: null
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        key: "select",
                                        name: "Шаг 2",
                                        noAntForm: true,
                                        form: (props) => {
                                            return (
                                                <div style={{ padding: "0px 10px" }}>
                                                    <div>Подтвердите выбор пользователя:</div>
                                                    <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                                    <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                                </div>
                                            )
                                        },
                                    }
                                ],
                                options: {
                                    initialValues: {},
                                },
                                title: "Добавить пользователя",
                                modal: {
                                    minWidth: "250px",
                                    title: "Новый пользователь",
                                }
                            }
                        ]}
                        modelActions={(item) => [
                            {
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    Modal.confirm({
                                        title: `Вы уверены что хотите удалить пользователя из черного списка?`,
                                        icon: <ExclamationCircleOutlined />,
                                        content: <User item={item.polzovatel} noborder={true} />,
                                        okText: "Да",
                                        okType: 'danger',
                                        cancelText: "Нет",
                                        onOk: () => {
                                            GET(auth, `/api/delete/school/cherniispisok/${item.ID}`,
                                                () => {
                                                    setCollection(deleteInArray(collection, item));
                                                }, errorCatch);
                                        },
                                    });
                                },
                            },
                        ]}
                    />}
                </div>
            </PageLayout>
        </div>
        <div className={"footer"}>
            <CapsuleMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} />

            {/* <TabsMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} /> */}
            {/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}

        </div>
    </div>)

}
